import { css } from 'linaria';

const divider = css`
  margin: var(--space-250) 0;
`;

const list = css`
  margin-top: var(--space-200);
`;

const listItem = css`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-50);
`;

const phoneSection = css`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin: var(--space-200) 0 var(--space-50);
`;

const phoneNumber = css`
  white-space: nowrap;
  color: var(--brand-primary);
`;

export const timeTable = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-250);
  margin-top: var(--space-200);
`;

export const timeSlot = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const warning = css`
  margin-bottom: var(--space-275);
`;

export const styles = {
  divider,
  list,
  listItem,
  phoneNumber,
  phoneSection,
  timeTable,
  timeSlot,
  warning,
};
